import React from 'react';

const EarthIcon = () => {
	return (
		<svg
			data-testid='earth-icon'
			fill='none'
			height='16'
			viewBox='0 0 16 16'
			width='16'
		>
			<path
				d='M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M13.3874 10.65L9.99368 8.56249C9.93527 8.52493 9.86895 8.5014 9.79993 8.49374L8.36868 8.29999C8.26189 8.28466 8.15304 8.30518 8.05917 8.35834C7.9653 8.41149 7.89171 8.49428 7.84993 8.59374L6.99368 10.5125C6.95342 10.6017 6.94026 10.7008 6.95581 10.7975C6.97137 10.8942 7.01496 10.9841 7.08118 11.0562L8.25618 12.325C8.30929 12.3834 8.34821 12.4532 8.36989 12.5291C8.39157 12.605 8.39544 12.6849 8.38118 12.7625L8.13743 14'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M4.06261 3.47504L3.50011 4.80004C3.45111 4.91767 3.44888 5.04956 3.49386 5.16879L4.21261 7.08129C4.2407 7.161 4.28878 7.23217 4.35225 7.28798C4.41572 7.34379 4.49246 7.38237 4.57511 7.40004L5.91261 7.68754C5.98685 7.70255 6.05656 7.73466 6.11623 7.78131C6.1759 7.82795 6.22388 7.88787 6.25636 7.95629L6.49386 8.45004C6.53606 8.53352 6.6003 8.60386 6.67962 8.65344C6.75895 8.70302 6.85033 8.72994 6.94386 8.73129H7.78761'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.53135 2.19379L10.1126 3.24379C10.1663 3.3425 10.1856 3.45627 10.1675 3.56716C10.1494 3.67805 10.0949 3.77977 10.0126 3.85629L8.33135 5.37504C8.3032 5.40191 8.27169 5.42502 8.2376 5.44379L7.46885 5.86879C7.39557 5.90767 7.31428 5.92906 7.23135 5.93129H5.89385C5.79532 5.93179 5.69907 5.96103 5.61692 6.01543C5.53477 6.06983 5.47027 6.14702 5.43135 6.23754L4.9126 7.46879'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default EarthIcon;
